<div class="service-page">
  <header class="page-hero">
    <h1>Herramientas digitales adaptadas a cómo trabaja tu empresa.</h1>
    <p class="hero-lead">
      Desarrollamos aplicaciones web, integraciones y herramientas internas cuando una solución
      estándar no encaja con la necesidad real.
    </p>
    <a class="button button-primary" routerLink="/contacto">Explícanos tu necesidad</a>
  </header>

  <section class="split-section" aria-labelledby="custom-need-title">
    <div class="section-heading">
      <h2 id="custom-need-title">
        Cuando el proceso del negocio no cabe en una herramienta genérica.
      </h2>
    </div>
    <ul class="check-list">
      <li>Una tarea depende de pasos manuales y repetidos.</li>
      <li>La información está repartida entre varias herramientas.</li>
      <li>El equipo necesita una aplicación para un flujo concreto.</li>
      <li>Una solución existente requiere una integración específica.</li>
    </ul>
  </section>

  <section aria-labelledby="custom-scope-title">
    <div class="section-heading">
      <h2 id="custom-scope-title">Tecnología al servicio de un objetivo definido.</h2>
      <p>
        La viabilidad y el alcance se valoran para cada necesidad antes de proponer una solución.
      </p>
    </div>
    <div class="feature-grid feature-grid-three">
      <article>
        <span>01</span>
        <h3>Aplicaciones web</h3>
        <p>Herramientas accesibles desde el navegador para resolver procesos concretos.</p>
      </article>
      <article>
        <span>02</span>
        <h3>Integraciones</h3>
        <p>Conexiones entre sistemas cuando sus capacidades y condiciones técnicas lo permiten.</p>
      </article>
      <article>
        <span>03</span>
        <h3>Herramientas internas</h3>
        <p>Soluciones enfocadas en organizar información o apoyar el trabajo del equipo.</p>
      </article>
    </div>
  </section>

  <section class="pricing-section" aria-labelledby="custom-price-title">
    <div>
      <h2 id="custom-price-title">Presupuesto cerrado</h2>
    </div>
    <p>
      El alcance y el importe se definen antes de comenzar según los flujos, usuarios,
      integraciones, datos y requisitos técnicos del proyecto. El presupuesto no incluye IVA.
    </p>
  </section>

  <section class="split-section" aria-labelledby="custom-projects-title">
    <div class="section-heading">
      <h2 id="custom-projects-title">Desarrollo adaptado a una necesidad concreta.</h2>
    </div>
    <ul class="check-list">
      <li>Intranets y áreas privadas.</li>
      <li>Aplicaciones internas y herramientas de gestión.</li>
      <li>Automatizaciones.</li>
      <li>Plataformas web.</li>
      <li>Integraciones complejas.</li>
      <li>Funcionalidades críticas para el negocio.</li>
    </ul>
  </section>

  <section class="faq-section" aria-labelledby="custom-faq-title">
    <div class="section-heading">
      <h2 id="custom-faq-title">Antes de plantear una solución a medida.</h2>
    </div>
    <div class="faq-list">
      <details>
        <summary>¿Tengo que definir la solución técnica?</summary>
        <p>
          No. Resulta más útil explicar el proceso actual, el problema y el resultado que necesita
          la empresa.
        </p>
      </details>
      <details>
        <summary>¿Podéis conectar herramientas que ya utilizamos?</summary>
        <p>
          Puede valorarse si las herramientas ofrecen opciones de integración adecuadas. Es
          necesario revisar cada sistema antes de confirmar el alcance.
        </p>
      </details>
      <details>
        <summary>¿Cómo se acota un proyecto personalizado?</summary>
        <p>
          Se ordenan las necesidades y prioridades para concretar qué debe resolver la primera
          propuesta y qué queda fuera.
        </p>
      </details>
    </div>
  </section>

  <section class="service-cta" aria-labelledby="custom-cta-title">
    <h2 id="custom-cta-title">Cuéntanos qué proceso quieres mejorar.</h2>
    <p>No hace falta llegar con especificaciones técnicas. Empieza por explicarnos el contexto.</p>
    <a class="button button-primary" routerLink="/contacto">Valorar una solución</a>
  </section>
</div>
